import script from "./AccountStatusInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountStatusInfo.vue?vue&type=script&setup=true&lang=ts"

import "./AccountStatusInfo.vue?vue&type=style&index=0&id=68253414&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68253414"]])

export default __exports__